<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  data: () => ({}),
  mounted() {},
  created() {
    this.$store.commit('loadRoles')
  },
  methods: {}
};
</script>

<style>
.rotate {
  transform: rotate(-180deg)
}
.v-overlay__content {
  width: 100%;
}

/*
** CUSTOM TABLE
*/

.customTable table, .customTable th, .customTable td {
  border: 1px solid black;
  border-collapse: collapse;
}
.table-header {
  background-color: #1976D2;
  color: white;
}
</style>
